import { ChangeDetectionStrategy, Component, computed, inject, input, output, viewChild, ViewEncapsulation } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatListItemIcon, MatListItemTitle, MatListOption, MatSelectionList, MatSelectionListChange } from '@angular/material/list';
import { MatMenu, MatMenuTrigger } from '@angular/material/menu';
import { MatTooltip } from '@angular/material/tooltip';
import { Store } from '@ngrx/store';
import { selectI18N } from '@src/suite/common/store/i18n/selectors/i18n.selectors';

import { ClickStopPropagationDirective, EnterStopPropagationDirective, SpaceStopPropagationDirective } from '../../directives/stop-propagation';

@Component({
    selector: 'st-item-layout-toggle',
    imports: [
        ClickStopPropagationDirective,
        EnterStopPropagationDirective,
        MatIcon,
        MatIconButton,
        MatListItemIcon,
        MatListItemTitle,
        MatListOption,
        MatMenu,
        MatMenuTrigger,
        MatSelectionList,
        MatTooltip,
        SpaceStopPropagationDirective,
    ],
    templateUrl: './st-item-layout-toggle.html',
    styleUrl: './st-item-layout-toggle.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'st-item-layout-toggle',
    },
})
export class StItemLayoutToggleComponent {
    private store = inject(Store);

    readonly isCondensed = input<boolean>(false);
    readonly showLabel = input<boolean>(false);
    readonly layoutChange = output<boolean>();

    private readonly menuTrigger = viewChild.required<MatMenuTrigger>('layoutMenuTrigger');
    private readonly selectionList = viewChild.required<MatSelectionList>('layoutSelectionList');

    readonly languageSettings = this.store.selectSignal(selectI18N);

    readonly tooltip = computed(() => {
        const viewLabel = this.isCondensed() ? this.languageSettings().PSTWebViewCondensedLabel : this.languageSettings().PSTWebViewCardLabel;
        return `${this.languageSettings().PSTWebLayoutLabel}: ${viewLabel}`;
    });

    onMenuOpened() {
        this.selectionList().options.first?.focus();
    }

    onSelectionChange(event: MatSelectionListChange) {
        const value = event.options[0]?.value as boolean;
        this.setLayout(value);
    }

    setLayout(isCondensed: boolean): void {
        this.layoutChange.emit(isCondensed);
        this.menuTrigger().closeMenu();
    }
}
